<template>
  <div class="user-card">
    <picture class="avatar">
      <img role="img" :src="user.avatar" :alt="initials" width="60" height="60" />
    </picture>
    <div>
      <header>{{ firstname }} {{ lastname }}</header>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserAvatar",
  props: ["user"],

  computed: {
    initials() {
      if (this.user.firstname && this.user.lastname) return `${this.user.firstname[0]}${this.user.lastname[0]}`;
      return "";
    },
    firstname() {
      return this.user.firstname ? this.user.firstname : `Expert ${this.user.id}`;
    },
    lastname() {
      return this.user.lastname ? this.user.lastname : "";
    },
  },
};
</script>
